<template>
	<el-row>
		<el-col :span="8">
			<div class="history_select">
				<el-select class="zt-select" popper-class="zt-select-popper" v-model="nodeSelect" size="default"
					style="width: 140px" :teleported="false">
					<el-option v-for="item in nodeOptions" :key="item.environmentId" :label="item.environmentName"
						:value="item.environmentId" />
				</el-select>
			</div>
		</el-col>
		<el-col :span="8">
			<div class="history_title">
				24小时气象数据历史记录图
			</div>
		</el-col>
		<el-col :span="8">
			<div class="history_datetime">
				<el-date-picker class="zt-date-picker" popper-class="zt-date-picker-popper" v-model="dateVlue"
					type="date" placeholder="开始日期" style="width: 140px;" size="default" />
			</div>
		</el-col>
	</el-row>
	<div class="echarts">
		<div class="draw1" ref="chartRef">

		</div>
	</div>

</template>

<script setup>
	import {
		GetWeatherNow,
		GetWeatherData,
		GetWeatherTime
	} from '@/api/api.js';
	import {
		ref,
		watch,
		onMounted
	} from 'vue';
	import * as echarts from 'echarts'
	let chartData1 = ref(null)
	const nodeSelect = ref('11');
	const nodeOptions = ref([])
	GetWeatherNow().then(res => {
		nodeOptions.value = res.data
		nodeSelect.value = res.data[0].environmentId
	}).catch(err => {
		console.log(err)
	})

	//处理日期初始值
	const dateVlue = ref(new Date());

	function setdateVlue() {
		const currentDate = new Date();
		currentDate.setMonth(currentDate.getMonth()); // 获取前一个月的日期
		const year = currentDate.getFullYear();
		const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，并补0
		const day = String(currentDate.getDate()).padStart(2, '0'); // 补0操作
		// 格式化日期为 yyyy-MM-dd
		dateVlue.value = `${year}-${month}-${day}`;
	}
	let select = ref();
	let selectvalue = ref('');
	let img = [
		'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABRCAYAAABFTSEIAAAACXBIWXMAAAsSAAALEgHS3X78AAAEp0lEQVR42u3cz4sjRRTA8W9Vd3Vn8mMmjj9WQWSRZQ+CsH+B7MnDIgiCd0E8CYJ/gOAIelo8ehUP/gF6WLw5/gMueFP2sIcF0dHd2Z1kknR11fOQZJJJMtlZd03H7HtQpNOTnpn+8Lrm1etmjIig8e/DKoECKqACKqCGAiqgAiqghgIqoAIqoIYCKqACKqCGAiqgAiqghgIqoAJudKTr+osZMNPvBUQBHwHsPF9fB9R0DeHMOQ6T6WOrhEzXBM4swDOL0M6CrArRVoq3t2dGUIb9fTvatg8ZZup1PDBgzPmy98mey6qfzjLz2WaWjEUZKEvGyi9nWyneMOvGIyFQo2Sbg4MUSChpU9IeTTUpJdsEajPZOJeJG5uBZj7rLLduWS5dGm6XNLEELOFUFj54ACJCaychkpDSASK3bwsXL0YgVpWJKwM0iy9Zy8HdGru7jvt3Pbu7w0wES7drTwAbjTHMGCsQcIAnYTC1/wRx0wEnl27JNgZI8HQ6Kc1mQq83RNzaMjPzXqDbjTQaJRFLxIyyMSxAXEkWrhrQzAAmo5HOjCQf7jflILxOkohL+aUPgV4vEGNJo+E5PAy02+UIMEwBxo0CPDP7Dg5SnEtpt1PA0e87XO25FOoh8IYIH2Y5b45RzGAQBiIltZoHxqMcjbksXAVgdc2EQMYzzzdotyeZWKuleULXJtwT4SODfC2QCWR+IF9KnjuX1Xbo99Op7LVE8iXlz0YBTk5SyLEEjo5OLuccEoFUvHfO+reuUPx4zftXAIcx1hdcF+/TvFab4A0Bs0VwqyhpVnkJT89/Q4DDQ0e77YCMwIUsFMeFZD856699URRvX4nxE4A/jbnxXp7v4Zw3ReGNSDHI8wFQjIafuoyn58L/fB6sth/Ybg9fez2TRC6QZcZYvgHsazF+MP7YCyLXcM7gvSXLDGBqYDg+NhwdmSpPoTrAkub0W+f4FSB1fDucIunMHSLpO8WAH0rSy8u+19MBCHB4OHzd2pI+CEUhpigEiN+l6WcdY252jLn5s7Wf472ImPcN8pUl/tEHoV4XWq1Ke4KrLmPsTA3oODpytFoOyJKSyzHyMSIxteWngMW5cSEdDJQUhTdZVgxOz3/+jFJm4+bA2e5JpNU6WZ4Fw99JwnWMKccwpeddP+B7GZTNUPKqybJy0O+Hs1YfMz9swwvpB8fbGDG0GuGkkK7V0hxSmZQpABI8l2z0v3sJf50qpAMJCd2qCulql3LD1lRGQjm7lEsDz0rkxTQOfiPPxUBcuJTbbhss/Y1eyi3NwsmKInmkZsKk5gtPUzNhvp11507CSy/X6XYStpvFudpZw1ZWIOF4Cq6SdtbKbioJyAhRTu3u9yMJXerN+ugvaQQsjcZ8Q3VnZwxlSDhe1lB9GjrSw5b+1avT8+Jw+979nNaOI6U3KpTrWAosxVQmygK4ld8X0ZtK/7eViExD7O1NQPb3T7fsl4/4sBpwYzPwjFbTo95Yl9l9Vd1YN1X/147HebSjary1AHyc5qc+XLQEQx9ve8Kg6xr6hKoCKqACKqCGAiqgAiqghgIqoAIqoIYCKqACKqCGAiqgAiqghgIq4JrHP8fEWV8FMTmOAAAAAElFTkSuQmCC',
		'image://data:image/png;base64,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',
		'image://data:image/png;base64,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',
		'image://data:image/png;base64,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',
	]
	let options = null;
	const chartRef = ref();
	// 定时任务
	let intervalId = null;
	const timingFn = () => {
		intervalId = setInterval(() => {
			const foundIndex = nodeOptions.value.findIndex(obj => obj['environmentId'] == nodeSelect.value);
			let nextObject = foundIndex !== -1 && foundIndex < nodeOptions.value.length - 1 ? nodeOptions
				.value[foundIndex + 1] : null;
			if (!nextObject) {
				nextObject = nodeOptions.value[0]
			}
			nodeSelect.value = nextObject.environmentId

		}, 15000);
	}

	onMounted(() => {
		timingFn();
		setdateVlue();

		watch(() => [nodeSelect.value, dateVlue.value], () => {

			let selectedDate = new Date(dateVlue.value).getTime();
			GetWeatherTime({
				deviceAddr: '40245907',
				environmentId: nodeSelect.value,
				beginTime: selectedDate,
				endTime: selectedDate + 24 * 60 * 60 * 1000
			}).then(ite => {

				options = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
						},
						textStyle: {
							color: '#ffffff',
						},
						borderColor: 'transparent',
						backgroundColor: '#066953',
						extraCssText: 'backdrop-filter: blur(6px);',
					},
					xAxis: {
						data: ite.data.map((item) => item.recordTime),
						type: 'category',
						boundaryGap: true,
						itemStyle: {
							borderColor: 'blue',
							color: '#ffffff'
						},
						axisLabel: {
							textStyle: {
								show: true,
								fontFamily: '微软雅黑',
								color: '#fff',

								fontSize: '12'
							}
						}
					},
					yAxis: {
						type: 'value',
						axisLine: {
							show: false,
							lineStyle: {
								color: 'white'
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: 'rgba(255,255,255,0.3)'
							}
						},
						axisLabel: {}
					},
					dataZoom: [{
						"show": true,
						"height": 12,
						"xAxisIndex": [
							0
						],
						bottom: '2%',
						"start": 30,
						"end": 60,
						// handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
						handleSize: '110%',
						handleStyle: {
							color: "#11a882",

						},
						textStyle: {
							color: "#11a882"
						},
						borderColor: "#11a882"
					}, {
						"type": "inside",
						"show": true,
						"height": 15,
						"start": 1,
						"end": 35
					}],
					grid: {
						left: '1%',
						top: '6%',
						right: '0%',
						bottom: '7%',
						containLabel: true
					},
					series: [{
						data: ite.data.map((item) => item.environmentValue),
						name: '值',
						type: 'line',
						symbol: 'circle',
						smooth: true,
						symbolSize: 7,
						lineStyle: {
							width: 1,
							type: 'solid'
						},
						tooltip: {
							formatter: '{b} : {c}'
						},
						itemStyle: {
							borderWidth: 1,
							borderColor: '#55ff00',
							color: '#55ff00'
						},
						areaStyle: {
							color: '#d5ffd4',
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
									[{
											offset: 0,
											color: '#d5ffd4'
										},
										{
											offset: 0.5,
											color: '#366d51'
										},
										{
											offset: 1,
											color: '#366d51'
										}
									],
									false
								),
								shadowBlur: 0
							}
						}
					}, ]
				}

				let myChart = echarts.init(chartRef.value);
				myChart.setOption(options)

			})

		});
	

	})
</script>

<style lang="scss">
	.history_select {
		text-align: left;
		padding-left: 20px;
	}

	.draw1 {
		width: 98%;

		margin: 0 auto;
		height: 200px;
	}

	.history_title {
		margin-top: 0px;
		height: 30px;
		font-size: 16px;
	}

	.history_datetime {
		text-align: right;
		padding-right: 20px;
	}

	.zt-select {
		$text-color: #fff; // 定义一个文本颜色变量，值为白色
		$border-color: #2dffd0; // 定义一个边框颜色变量
		$active-border-color: #55aa00; // 定义一个活动状态的边框颜色变量

		.el-input {
			--el-input-border-color: #{$border-color} !important;
			--el-input-bg-color: transparent !important;
			--el-input-text-color: #{$text-color} !important;

			--el-select-border-color-hover: #2dffd0;
			--el-select-input-focus-border-color: #55aa00;

		}

		svg {
			fill: #{$text-color} !important; // 设置 SVG 图形的填充颜色为文本颜色
		}




	}

	// Dropdown popper styles override
	.zt-select-popper {
		--el-text-color-secondary: #fff !important;
		/* 设置字体颜色为白色 */
		--el-border-color-light: #ffffff !important;
		/* 设置边框颜色为白色 */
		--el-bg-color-overlay: rgba(24, 144, 116, 1.0) !important;

		/* 设置弹出层背景色为rgba(24, 144, 116, 1.0) */
		span {
			color: white;
		}

		.el-select-dropdown__item:hover {
			background-color: rgba(0, 202, 255, 0.33) !important;

			/* 设置选择项悬浮时的背景色为绿色 */
			span {
				color: rgba(85, 255, 127, 1.0);
			}
		}


	}


	.zt-date-picker {
		$text-color: #fff; // 定义一个文本颜色变量，值为白色
		$border-color: #2dffd0; // 定义一个边框颜色变量
		$active-border-color: #55aa00; // 定义一个活动状态的边框颜色变量

		--el-input-border-color: #{$border-color} !important; // 使用 CSS 自定义属性设置输入框的边框颜色
		--el-input-focus-border-color: #{$active-border-color} !important; // 当输入框聚焦时的边框颜色
		--el-input-hover-border-color: #2dffd0 !important; // 当输入框聚焦时的边框颜色
		--el-input-bg-color: transparent !important; // 输入框的背景颜色设置为透明
		--el-input-text-color: #{$text-color} !important; // 输入框的文本颜色
		--el-text-color-regular: #{$text-color}; // 常规文本颜色

		.el-icon {
			color: #{$text-color}; // 设置图标颜色为之前定义的文本颜色
		}

		svg {
			fill: #{$text-color} !important; // 设置 SVG 图形的填充颜色为文本颜色
		}
	}

	.zt-date-picker-popper {
		// 定义一个日期选择器弹出层的边框颜色变量
		$popper-border-color: #ffffff;

		// 定义一个日期选择器弹出层的文本颜色变量
		$popper-text-color: #ffffff;

		// 定义一个日期选择器弹出层文本悬停时的颜色变量
		$popper-text-hover-color: #2dffd0;

		// 定义一个日期选择器弹出层文本激活（如选中）时的颜色变量
		$popper-text-active-color: #e3e13d;

		// 定义一个日期选择器弹出层的背景遮罩颜色变量
		$popper-overlay-color: rgba(24, 144, 116, 1.0);

		// 定义一个日期在当前选中范围内的背景颜色变量
		$popper-current-bg-color: rgba(24, 144, 116, 0.3);

		// 定义一个日期在指定范围内的背景颜色变量
		$inrange-bg-color: rgba(85, 255, 0, 0.3);

		// 定义一个日期在指定范围内悬停时的背景颜色变量
		$inrange-hover-bg-color: rgba(85, 255, 127, 0.5);

		// 定义一个日期在指定范围内的文本颜色变量
		$inrange-text-color: #00d8d8;

		// 将自定义的文本颜色变量应用到Element UI的常规文本颜色变量上
		--el-text-color-regular: #{$popper-text-color};

		// 将自定义的背景遮罩颜色变量应用到Element UI的背景遮罩颜色变量上
		--el-bg-color-overlay: #{$popper-overlay-color};

		// 开始定义.el-icon的样式
		.el-icon {
			// 设置图标的默认颜色
			color: $popper-text-color;

			// 设置图标内部SVG的颜色
			svg {
				fill: #{$popper-text-color};
			}

			// 定义图标悬停时的样式
			&:hover {
				// 悬停时图标的颜色
				color: #{$popper-text-hover-color};

				// 悬停时图标内部SVG的颜色
				svg {
					fill: #{$popper-text-hover-color};
				}
			}
		}

		// 定义在指定范围内的日期的样式
		td.in-range {
			// 设置文本颜色，并强制应用该样式（!important）
			color: #{$inrange-text-color} !important;
		}

		// 开始定义.el-date-range-picker的样式
		.el-date-range-picker {
			// 设置日期选择器的文本颜色
			--el-datepicker-text-color: #{$popper-text-color};

			// 设置日期选择器中不可选日期的文本颜色
			--el-datepicker-off-text-color: #{$popper-text-color};

			// 设置日期选择器的头部文本颜色
			--el-datepicker-header-text-color: #{$popper-text-color};

			// 设置日期选择器中图标的颜色
			--el-datepicker-icon-color: #{$popper-text-color};

			// 设置日期选择器的边框颜色
			--el-datepicker-border-color: #{$popper-border-color};

			// 设置日期选择器的内部边框颜色
			--el-datepicker-inner-border-color: #{$popper-border-color};

			// 设置在指定范围内的日期的背景颜色
			--el-datepicker-inrange-bg-color: #{$inrange-bg-color};

			// 设置在指定范围内悬停时的日期的背景颜色
			--el-datepicker-inrange-hover-bg-color: #{$inrange-hover-bg-color};

			// 设置激活（如选中）日期的颜色（这里使用了Element UI的原色变量）
			--el-datepicker-active-color: var(--el-color-primary);

			// 设置日期悬停时的文本颜色
			--el-datepicker-hover-text-color: #{$popper-text-hover-color};
		}
	}
</style>